import React from 'react';
import { LANGUAGES, getLanguagesByRegion } from '../constants/languages';

/**
 * Reusable language selection dropdown component
 * Supports both flat and grouped display modes
 */
const LanguageSelect = ({
  id,
  name,
  value,
  onChange,
  grouped = false,
  placeholder = "Select language",
  required = false,
  disabled = false,
  className = ""
}) => {
  if (grouped) {
    // Render grouped by region
    const languagesByRegion = getLanguagesByRegion();

    return (
      <select
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        disabled={disabled}
        className={className}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {Object.entries(languagesByRegion).map(([region, languages]) => (
          <optgroup key={region} label={region}>
            {languages.map(lang => (
              <option key={lang.code} value={lang.code}>
                {lang.name}
              </option>
            ))}
          </optgroup>
        ))}
      </select>
    );
  }

  // Render flat list
  return (
    <select
      id={id}
      name={name}
      value={value}
      onChange={onChange}
      required={required}
      disabled={disabled}
      className={className}
    >
      {placeholder && <option value="">{placeholder}</option>}
      {LANGUAGES.map(lang => (
        <option key={lang.code} value={lang.code}>
          {lang.name}
        </option>
      ))}
    </select>
  );
};

export default LanguageSelect;
